import React from 'react'
import {
  Stack,
  Heading,
  Text,
  Button,
  Card,
  UserChip,
  Icon,
  ConfirmButton
} from '@/components/lib'
import utils from '@/utils/utils'
import useStore from '@/store'
import { FaTrash } from 'react-icons/fa'

function personnelMatch (personnel, userId) {
  return (personnel || []).some((id) => String(id) === String(userId))
}

/**
 * Participant calendar event summary for detail modal (calendar).
 */
export default function ParticipantEventCard ({
  event,
  trialId,
  onEdit,
  onDelete,
  deletingId
}) {
  const { user, trial, getTrialUsers } = useStore()
  const trialUsers = getTrialUsers(trialId)
  const canWrite = utils.canWriteTrial(user, trial)

  return (
    <Card>
      <Stack gap={4}>
        <Heading size='sm'>{event.title || 'Event'}</Heading>
        {event.startsAt && (
          <Text fontSize='sm'>
            {utils.formatDateTime(event.startsAt)}
          </Text>
        )}
        {event.description && (
          <Text fontSize='sm' whiteSpace='pre-wrap'>
            {event.description}
          </Text>
        )}
        {(event.personnel?.length > 0) && (
          <Stack direction='row' gap={2} flexWrap='wrap' alignItems='center'>
            {trialUsers
              .filter((u) => personnelMatch(event.personnel, u._id))
              .map((u) => (
                <UserChip key={u._id} user={u} compact />
              ))}
          </Stack>
        )}
        {canWrite && (onEdit || onDelete) && (
          <Stack direction='row' gap={2} flexWrap='wrap' alignItems='center'>
            {onEdit && (
              <Button size='sm' variant='outline' onClick={() => onEdit(event)}>
                Edit
              </Button>
            )}
            {onDelete && (
              <ConfirmButton
                trigger={
                  <Button
                    size='sm'
                    variant='ghost'
                    isLoading={deletingId === event._id}
                  >
                    <Icon as={FaTrash} />
                  </Button>
                }
                header='Delete this event?'
                body='This cannot be undone.'
                onConfirm={() => onDelete(event._id)}
                actionColor='red'
              />
            )}
          </Stack>
        )}
      </Stack>
    </Card>
  )
}
